import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { industryService } from "../shared/api/industryService";

interface Props {
	industryId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const IndustryListContextMenu: FC<Props> = ({ industryId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(() => industryService.usages(industryId).then((r) => r.data.data), [industryId]);

	const canUpdate = useHasPermission<PermissionName>(["industry.update"]);
	const canDelete = useHasPermission<PermissionName>(["industry.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Industry")}
						confirmationBody={t("Are you sure you want to delete this industry?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
